// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var RichTextEditor$ReactHooksTemplate = require("../common/RichTextEditor.res.js");

function QuestionTextPreview(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Question Text",
                              className: "text-aurometalsaurus text-sm mb-2 font-normal"
                            }),
                        JsxRuntime.jsx(RichTextEditor$ReactHooksTemplate.make, {
                              value: props.text,
                              onChange: props.onTitleChange,
                              placeholder: "Enter Text",
                              minHeight: "48px",
                              singleLine: true,
                              showAlignment: false,
                              showLists: false
                            })
                      ],
                      className: "mb-8"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Description",
                              className: "text-aurometalsaurus text-sm mb-2 font-normal"
                            }),
                        JsxRuntime.jsx(RichTextEditor$ReactHooksTemplate.make, {
                              value: props.description,
                              onChange: props.onDescriptionChange,
                              placeholder: "Enter Description",
                              minHeight: "72px"
                            })
                      ],
                      className: "mb-10"
                    })
              ]
            });
}

var make = QuestionTextPreview;

exports.make = make;
/* react/jsx-runtime Not a pure module */
